import { MutationTree } from 'vuex';
import {CallDetailItem, StatisticState, CallDetailEventsItem, CallGroupSummary, CallGroupIncomingSummary} from './types';

export const mutations: MutationTree<StatisticState> = {
    
    setCallMessagesCount: (state, data) => {
        state.callStatisticGroupMessageCount = data;
    },
    setCallStatisticGroup: (state, data) => {
        state.callStatisticGroup = data;
    },
    setCallStatisticGroupSummary: (state, data: CallGroupSummary) => {
      state.callStatisticGroupSummary = data;
    },
    setCallIncomingMessagesCount: (state, data) => {
        state.callStatisticGroupIncomingMessageCount = data;
    },
    setCallStatisticGroupIncoming: (state, data) => {
        state.callStatisticGroupIncoming = data;
    },
    setCallStatisticGroupIncomingSummary: (state, data: CallGroupIncomingSummary) => {
        state.callStatisticGroupIncomingSummary = data;
    },

    setCallStatisticDetail: (state, data) => {
        state.callStatisticDetail = data
    },
    pushCallStatisticDetail: (state, data: CallDetailItem[]) => {
        state.callStatisticDetail = state.callStatisticDetail.concat(data)
    },
    setCallStatisticDetailFlag: (state, data) => {
        state.callStatisticDetailFlag = data
    },
    setCallStatisticDetailIncoming: (state, data) => {
        state.callStatisticDetailIncoming = data;
    },
    setCallDetailEvents: (state, data: CallDetailEventsItem[]) => {
      state.callDetailEvents = data;
    }
};